import * as appsettings from "../appsettings";
import * as listbox from "../listbox";

let _msg_notsaved = "";

/**
* Enable save button
*/
function enableSaveButton(): void {
    const btnSave = document.getElementById("saveButton");
    btnSave.removeAttribute("disabled");
}

function lDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}



export function initialize(notsaved: string): void {
    _msg_notsaved = notsaved;
}


/**
* Move user to the left
*/
export function leftClicked(): void {
    enableSaveButton();
    listbox.moveItems("NodeWebServiceCredentials_CplSelected", "NodeWebServiceCredentials_CplNotSelected", "#NodeWebServiceCredentials_Validation", lDataChangedNotSavedYet());
}

/**
* Move user to the right
*/
export function rightClicked(): void {
    enableSaveButton();
    listbox.moveItems("NodeWebServiceCredentials_CplNotSelected", "NodeWebServiceCredentials_CplSelected", "#NodeWebServiceCredentials_Validation", lDataChangedNotSavedYet());
}

/**
* Save button clicked
*/
export function saveButtonClicked(actionUrl: string, groupId: number): void {

    const json = $("#NodeWebServiceCredentials_CplSelected").data("kendoListBox").dataSource.view().toJSON();
    const list = json.slice();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { list: kendo.stringify(list), id: groupId },
        success: function (responseData) {

            $('#NodeWebServiceCredentials_Validation').text("");

            var color = (responseData.Succesfully ? 'green' : 'red');
            $('#NodeWebServiceCredentials_Validation').text(responseData.Message);
            $('#NodeWebServiceCredentials_Validation').attr('style', 'color:' + color);

            var btnSave = document.getElementById("saveButton");
            btnSave.setAttribute("disabled", "disabled");
        }
    });
}
